// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1eGc4","right":"styles_right__7U_bX"};